import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [ 
        //首页
        {
            path: '/',
            name:'/',
            component: () => import("@/mobile/Home/HomeIndex.vue"),
        },
        // 心理测评
        {
            path: '/appraisal',
            name:'/appraisal',
            component: () => import("@/mobile/Home/AppraisalIndex.vue")
        },
        // 咨询师预约
        {
            path: '/subscribe',
            name:'/subscribe',
            component: () => import("@/mobile/Home/SubscribeIndex.vue")
        },
        // 咨询师预约详情
        {
            path: '/subscribeDetails',
            name:'/subscribeDetails',
            component: () => import("@/mobile/Home/SubscribeDetails.vue")
        },
        // 立即咨询
        {
            path: '/refer',
            name:'/refer',
            component: () => import("@/mobile/Home/ReferIndex.vue")
        },
        // 文章阅读
        {
            path: '/essay',
            name:'/essay',
            component: () => import("@/mobile/Home/EssayIndex.vue")
        },
        // 文章详情
        {
            path: '/details',
            name:'/details',
            component: () => import("@/mobile/Home/EssayDetails.vue")
        },
        // 会员选择
        {
            path: '/select',
            name:'/select',
            component: () => import("@/mobile/Home/SelectClub.vue")
        },
        // 个人中心
        {
            path: '/my',
            name:'/my',
            component: () => import("@/mobile/Home/MyIndex.vue")
        },
        // 咨询师个人中心
        {
            path: '/counselor',
            name:'/counselor',
            component: () => import("@/mobile/Home/CounselorMy.vue")
        },
        // 平台问答列表
        {
            path: '/terrace',
            name:'/terrace',
            component: () => import("@/mobile/Home/TerraceIndex.vue")
        },
        // 平台问答详情
        {
            path: '/terraceDetails',
            name:'/terraceDetails',
            component: () => import("@/mobile/Home/TerraceDetails.vue")
        },
        // 登录
        {
            path: '/login',
            name:'/login',
            component: () => import("@/mobile/Login/LoginIndex.vue")
        },
        // 基本信息
        {
            path: '/editPersonage',
            name:'/editPersonage',
            component: () => import("@/mobile/MyPersonage/EditPersonage.vue")
        },
        // 私信列表
        {
            path: '/letter',
            name:'/letter',
            component: () => import("@/mobile/MyPersonage/LetterList.vue")
        },
        // 问答列表
        {
            path: '/answers',
            name:'/answers',
            component: () => import("@/mobile/MyPersonage/AnswersList.vue")
        },
        // 预约订单
        {
            path: '/make',
            name:'/make',
            component: () => import("@/mobile/MyPersonage/MakeIndex.vue")
        },
        // 会员订单
        {
            path: '/member',
            name:'/member',
            component: () => import("@/mobile/MyPersonage/MemberList.vue")
        },
        // 测试记录
        {
            path: '/record',
            name:'/record',
            component: () => import("@/mobile/MyPersonage/TestRecord.vue")
        },
        
        // 咨询师入驻申请
        {
            path: '/apply',
            name:'/apply',
            component: () => import("@/mobile/MyPersonage/ApplyIndex.vue")
        },
        // 咨询师基本信息
        {
            path: '/editCounselor',
            name:'/editCounselor',
            component: () => import("@/mobile/MyCounselor/EditCounselor.vue")
        },
        // 预约信息
        {
            path: '/appointment',
            name:'/appointment',
            component: () => import("@/mobile/MyCounselor/AppointmentInformation.vue")
        },
        // 预约订单
        {
            path: '/appointmentOrder',
            name:'/appointmentOrder',
            component: () => import("@/mobile/MyCounselor/AppointmentOrder.vue")
        },
        // 私信列表
        {
            path: '/message',
            name:'/message',
            component: () => import("@/mobile/MyCounselor/PrivateMessageList.vue")
        },
        // 问答大厅
        {
            path: '/question',
            name:'/question',
            component: () => import("@/mobile/MyCounselor/QuestionAndAnswerHall.vue")
        },
        // 黑名单列表
        {
            path: '/black',
            name:'/black',
            component: () => import("@/mobile/MyCounselor/BlacksList.vue")
        },
        // 个人评价
        {
            path: '/evaluation',
            name:'/evaluation',
            component: () => import("@/mobile/MyCounselor/PersonalEvaluation.vue")
        },
        {
            path: "/blank",
            name: "/blank",
            component: () => import("@/pages/blank/blankIndex.vue")
        },
        // 登录加载中
        {
            path: '/load',
            name:'/load',
            component: () => import("@/mobile/Login/LoadIndex.vue")
        },
    ]
})



export default router;